import api from "./api";

/** Resposta típica de GET /v2/gn/saldo (Efí), repassada pelo backend. */
export type SaldoEfiApiResponse = {
  saldo?: string;
  bloqueios?: {
    judicial?: string;
    med?: string;
    total?: string;
  };
};

export type SaldoEfiParsed = {
  saldoDisponivel: number;
  bloqueioTotal: number;
};

function parseMoneyEfi(value: string | undefined): number {
  if (value == null || value === "") return 0;
  const n = Number(String(value).replace(",", "."));
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0;
}

export function parseSaldoEfiResponse(res: SaldoEfiApiResponse): SaldoEfiParsed {
  return {
    saldoDisponivel: parseMoneyEfi(res.saldo),
    bloqueioTotal: parseMoneyEfi(res.bloqueios?.total),
  };
}

export async function fetchSaldoEfi(): Promise<SaldoEfiApiResponse> {
  const res = await api.get<SaldoEfiApiResponse>("/saldo-efi");
  if (res.status >= 400) {
    const msg =
      (res.data as { message?: string })?.message ??
      "Não foi possível obter o saldo da Efí.";
    throw new Error(typeof msg === "string" ? msg : "Erro ao consultar saldo.");
  }
  return res.data;
}
